/**
 * Helper condiviso per stampare una pagina Policy (Privacy, Terms, Reclami...).
 * Sostituisce il pattern `document.write()` (linter XSS warning) con
 * un approccio sicuro basato su **Blob URL** (standard moderno).
 *
 * Vantaggi:
 * - Nessun `document.write` (evita XSS warning)
 * - Gestisce correttamente CSP strict
 * - HTML sanitizzato via costruzione template stringa (no input utente)
 */

const DEFAULT_STYLE = `
  body{font-family:Georgia,serif;max-width:800px;margin:40px auto;padding:0 20px;color:#1a1a1a;line-height:1.7;font-size:14px}
  h1{font-size:22px;border-bottom:2px solid #163321;padding-bottom:10px;color:#163321}
  h2{font-size:16px;color:#163321;margin-top:30px}
  h3{font-size:14px;margin-top:20px}
  table{width:100%;border-collapse:collapse;margin:15px 0}
  th,td{border:1px solid #ddd;padding:8px;text-align:left;font-size:13px}
  th{background:#f5f4f0}
  ul{padding-left:20px}
  li{margin:4px 0}
  .header{text-align:center;margin-bottom:30px}
  .header img{height:40px}
  .footer{margin-top:40px;padding-top:20px;border-top:1px solid #ddd;font-size:11px;color:#666;text-align:center}
  @media print{body{margin:0}}
`;

/**
 * Genera e apre (con stampa automatica) un documento policy formattato per PDF.
 *
 * @param {Object} opts
 * @param {string} opts.title              Titolo del documento
 * @param {string} opts.contentElementId   ID dell'elemento DOM con il contenuto
 * @param {string} [opts.headerHtml]       HTML opzionale dell'header
 */
export function printPolicyPage({ title, contentElementId, headerHtml }) {
  const contentEl = document.getElementById(contentElementId);
  if (!contentEl) return;

  const header = headerHtml ?? `<div class="header"><strong>COLUCCI ASSICURATORI</strong><br>CHRISTIAN E CIRO COLUCCI S.A.S. &mdash; P.IVA 07618011212</div>`;
  const footer = `<div class="footer">Documento generato il ${new Date().toLocaleDateString("it-IT")} &mdash; Colucci Assicuratori S.A.S. &mdash; www.colucciassicuratori.com</div>`;

  const html = `<!DOCTYPE html>
<html lang="it">
<head><meta charset="utf-8"><title>${title}</title><style>${DEFAULT_STYLE}</style></head>
<body>
${header}
${contentEl.innerHTML}
${footer}
<script>window.addEventListener('load',function(){setTimeout(function(){window.print();},300);});</script>
</body>
</html>`;

  // Approccio sicuro (no document.write): Blob URL su nuova finestra
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (!win) {
    // Pop-up bloccato: fallback scaricabile
    const a = document.createElement("a");
    a.href = url;
    a.download = `${title.replace(/[^a-z0-9\-]+/gi, "_")}.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  // Revoca URL dopo tempo sufficiente a stampare
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
